import React from 'react';
import LocationPicker from './location_picker';

const LocationModal = ({
  showModal,
  selectedDeliveryCoords,
  onLocationSelect,
  onClose
}) => {
  if (!showModal) return null;

  return (
    <div
      className='location-modal-overlay'
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 2000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }}
    >
      <div
        className='location-modal-content'
        style={{
          backgroundColor: '#fff',
          borderRadius: '10px',
          width: '100%',
          maxWidth: '900px',
          maxHeight: '90vh',
          overflow: 'visible',
          boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px',
          borderBottom: '1px solid #eee'
        }}>
          <div style={{ fontSize: '18px', fontWeight: 600 }}>Select Delivery Location</div>
          <button
            type='button'
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              fontSize: '18px',
              cursor: 'pointer'
            }}
            aria-label='Close location selector'
          >
            ✕
          </button>
        </div>

        <div style={{ padding: '16px', overflowY: 'auto', overflowX: 'hidden' }}>
          <LocationPicker
            initialLocation={selectedDeliveryCoords}
            onLocationSelect={onLocationSelect}
          />
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
          padding: '14px 16px',
          borderTop: '1px solid #eee'
        }}>
          <button
            type='button'
            onClick={onClose}
            className='nav-button prev-button'
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationModal;
